import { BAlert, BContainer } from 'bootstrap-vue'

export default {
    render() {
        return (
            <BContainer class="mt-2 mb-5">
                <BAlert show variant="danger">This page doesn't exist!</BAlert>
            </BContainer>
        )
    }
}